import * as recommandations from '../../../config/recommandations'

export const liens = [
  {
    label: 'Stratégie thérapeutique du patient vivant avec un diabète de type 2',
    date: 'Juin 2024',
    url: 'https://www.has-sante.fr/upload/docs/application/pdf/2024-06/strategie_therapeutique_du_patient_vivant_avec_un_diabete_de_type_2_-_recommandations.pdf',
    recommandation: recommandations.has2024
  },
  {
    label: 'Obésité de l’adulte : prise en charge de 2e et 3e niveaux (Partie II : pré et post-chirurgie bariatrique)',
    date: 'Février 2024',
    url: 'https://www.has-sante.fr/upload/docs/application/pdf/2024-02/reco369_recommandations_obesite_2e_3e_niveaux_ii_cd_2024_02_08_preparation_mel.pdf',
    recommandation: recommandations.has2024,
    id: 'has2024_obesite'
  },
  {
    label: 'Prise de position de la Société Francophone du Diabète (SFD) sur les stratégies d\'utilisation des traitements anti-hyperglycémiants dans le diabète de type 2',
    date: 'Décembre 2023',
    url: 'https://www.sfdiabete.org/sites/www.sfdiabete.org/files/files/ressources/1-s2.0-s1957255723002298-main.pdf',
    recommandation: recommandations.sfd2023
  },
  {
    label: 'ESC Guidelines for the management of cardiovascular disease in patients with diabetes',
    date: 'Août 2023',
    url: 'https://academic.oup.com/eurheartj/article/44/39/4043/7238227',
    recommandation: recommandations.esc2023
  },
  {
    label: 'Glycemic Targets: Standards of Care in Diabetes - 2023 (ADA)',
    date: 'Décembre 2022',
    url: 'https://diabetesjournals.org/care/article-pdf/46/Supplement_1/S97/693609/dc23s006.pdf',
    recommandation: recommandations.ada2023
  },
  {
    label: 'Older Adults: Standards of Care in Diabetes - 2023 (ADA)',
    date: 'Décembre 2022',
    url: 'https://diabetesjournals.org/care/article-pdf/46/Supplement_1/S216/693585/dc23s013.pdf',
    recommandation: recommandations.ada2023
  },
  {
    label: 'Management of Hyperglycemia in Type 2 Diabetes, 2022. A Consensus Report by the American Diabetes Association (ADA) and the European Association for the Study of Diabetes (EASD)',
    date: 'Septembre 2022',
    url: 'https://diabetesjournals.org/care/article-pdf/45/11/2753/691567/dci220034.pdf',
    recommandation: recommandations.adaeasd2022
  },
  {
    label: 'Diabetes Management in Chronic Kidney Disease: A Consensus Report by the American Diabetes Association (ADA) and Kidney Disease: Improving Global Outcomes (KDIGO)',
    date: 'Juin 2022',
    url: 'https://kdigo.org/wp-content/uploads/2018/03/ADA-KDIGO-Consensus-Report-Diabetes-CKD-Diabetes-Care-2022.pdf',
    recommandation: recommandations.adakdigo2022
  },
  /*
  {
    label: 'ADA - Glycemic Targets: Standards of Medical Care in Diabetes',
    date: 'Décembre 2021',
    url: 'https://diabetesjournals.org/care/article/45/Supplement_1/S83/138927/6-Glycemic-Targets-Standards-of-Medical-Care-in'
  },
  {
    label: 'ADA - Pharmacologic Approaches to Glycemic Treatment: Standards of Medical Care in Diabetes',
    date: 'Décembre 2021',
    url: 'https://diabetesjournals.org/care/article/45/Supplement_1/S125/138908/9-Pharmacologic-Approaches-to-Glycemic-Treatment'
  },
  {
    label: 'ADA - Older Adults: Standards of Medical Care in Diabetes',
    date: 'Décembre 2021',
    url: 'https://diabetesjournals.org/care/article/45/Supplement_1/S195/138920/13-Older-Adults-Standards-of-Medical-Care-in'
  },
   */
  {
    label: 'ESC Guidelines on cardiovascular disease prevention in clinical practice',
    date: 'Août 2021',
    url: 'https://academic.oup.com/eurheartj/article/42/34/3227/6358713',
    recommandation: recommandations.esc2021
  },
  {
    label: 'Évaluation du risque et dépistage de la maladie coronaire chez le patient diabetique asymptomatique. Consensus de la société française de cardiologie et de la société francophone de diabétologie',
    date: 'Mars 2021',
    url: 'https://www.sfdiabete.org/sites/www.sfdiabete.org/files/files/ressources/position_paper_sfc_sfd_march_2021.pdf',
    recommandation: recommandations.sfdsfc2021
  },
  {
    label: '2019 Update to: Management of Hyperglycemia in Type 2 Diabetes, 2018. A Consensus Report by the American Diabetes Association (ADA) and the European Association for the Study of Diabetes (EASD)',
    date: 'Novembre 2019',
    url: 'https://care.diabetesjournals.org/content/diacare/early/2019/12/18/dci19-0066.full.pdf',
    recommandation: recommandations.ada2019
  },
  {
    label: 'ESC Guidelines on diabetes, pre-diabetes and cardiovascular diseases',
    date: 'Septembre 2019',
    url: 'https://www.escardio.org/static-file/Escardio/Guidelines/Publications/_Slide%20Set/2019%20Diabetes%20Slide-set%20for%20web.pptx',
    recommandation: recommandations.esc2019
  }
]
